// @flow

import ApiObject from '../ApiObject';

export default class RestaurantRoom extends ApiObject {

  static NAME_MAX_LENGTH = 30;

  id: string = '';

  name: string = '';
}
